import { render } from "./ProductCenterView.vue?vue&type=template&id=691ae292&scoped=true"
import script from "./ProductCenterView.vue?vue&type=script&lang=js"
export * from "./ProductCenterView.vue?vue&type=script&lang=js"

import "./ProductCenterView.vue?vue&type=style&index=0&id=691ae292&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691ae292"]])

export default __exports__